import type { TextColumnProps } from '@modules/page-builder/types';
import { RevampRichText } from './RevampRichText';
import { RevampProfessionalCtas } from './RevampProfessionalCtas';

import { cn } from '@rocco/utils/cn';
import {
    REVAMP_QUOTE_FRAME,
    REVAMP_QUOTE_NAME_PROSE,
    REVAMP_QUOTE_PROSE,
    REVAMP_QUOTE_WIDTH_FULL,
} from '../../util/article-prose';

interface RevampQuoteModuleProps {
    column: TextColumnProps;
    professional?: { title: string; link: string };
}

/**
 * Full-width pull quote (Figma "Page Builder / Quote / full"): the hairline
 * 129px in from the page's edge, the quote 25px off it on a 1160px measure,
 * the professional's name as the attribution 62px under, and their CTA pills.
 * Attribution/CTAs are derived from the article's professional — the quote
 * module's CMS data is the text only.
 */
export const RevampQuoteModule = ({
    column,
    professional,
}: RevampQuoteModuleProps) => {
    return (
        <div className="w-full">
            <div className={cn(REVAMP_QUOTE_FRAME, REVAMP_QUOTE_WIDTH_FULL)}>
                {/* The quote and the name are one group, spaced tighter than
                    the container's own gap: the name credits the line above
                    it, so it belongs with that line rather than sitting
                    halfway between it and the buttons. */}
                <div className="flex w-full flex-col gap-8 md:gap-[3.875rem]">
                    <RevampRichText
                        contentHTML={column.contentHTML}
                        // Neue Haas Text at Roman, 80px at 110%, tracked in:
                        // the design's quote, as one line of type across the
                        // measure rather than a block on a measure of its own.
                        className={REVAMP_QUOTE_PROSE}
                    />
                    {professional?.title && (
                        <p className={REVAMP_QUOTE_NAME_PROSE}>
                            {professional.title}
                        </p>
                    )}
                </div>
                {professional && (
                    <RevampProfessionalCtas
                        professional={professional}
                        placement="quote"
                    />
                )}
            </div>
        </div>
    );
};
